/* eslint-disable */
const $blogFilter = $('.js-blog-filter');
$blogFilter.on('change', () => {
  $blogFilter.submit();
});